import React from "react";

const PhoneIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4069_16617)">
      <path
        d="M10.431 3.21411H6.09766C4.99309 3.21411 4.09766 4.10954 4.09766 5.21411V13.5474C4.09766 14.652 4.99309 15.5474 6.09766 15.5474H10.431C11.5356 15.5474 12.431 14.652 12.431 13.5474V5.21411C12.431 4.10954 11.5356 3.21411 10.431 3.21411Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.59766 13.2141H8.93099"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4069_16617">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.265625 0.380615)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default PhoneIcon;
